<div class="flex h-full flex-col lg:mx-auto lg:max-w-2xl">
    <div
        class="border-b border-solid border-opacity-10 bg-[var(--color-panel)] py-2 dark:border-contrast-yellow md:invisible">
        <div class="flex flex-row items-center justify-between">
            <ion-button
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="handleBackClicked()"
                color="secondary"
                fill="clear">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    [src]="(assetsPath$ | async) + '/img/journey-planner/icon-arrow.svg'"
                    aria-hidden="true">
                </ion-icon>
            </ion-button>
            <h1 class="text-base font-bold leading-5">
                {{ 'ADD_NOTIFICATIONS_SIDE_TITLE' | translate }}
            </h1>
            <div class="w-12"></div>
        </div>
    </div>

    <div class="flex-1 overflow-hidden p-4">
        <!--Input-->
        <ion-item class="relative mb-4 rounded-lg bg-white shadow-md" lines="none" detail="false">
            <ion-icon
                class="text-old_silver h-7 w-7 dark:text-contrast-black"
                [title]="'SEARCH' | translate"
                name="search-outline"></ion-icon>
            <ion-input
                class="ml-2 text-base"
                #input
                [value]="searchValue"
                [placeholder]="'ADD_NOTIFICATIONS_SEARCH_ROUTES_STOPS' | translate"
                (ionChange)="onSearchChange($event.target.value)"
                clearInput>
            </ion-input>
        </ion-item>

        <ng-container *ngIf="AddNotificationsViewModel$ | async as vm">
            <!--Results-->
            <div
                class="overflow-y-auto"
                *ngIf="searchValue?.length > 0 && vm.results?.stopRoutes?.length > 0"
                style="max-height: calc(100vh - 200px)">
                <div class="h-4 bg-gray-100 shadow-t-md-inset dark:bg-contrast-black"></div>
                <div class="bg-white px-4">
                    <ng-container *ngFor="let searchItem of vm.results.stopRoutes; let i = index">
                        <div
                            class="border-ironside_grey-100 border-t border-solid px-4 dark:border-contrast-yellow"
                            *ngIf="i !== 0"></div>
                        <rwidget-search-item
                            [searchItem]="searchItem"
                            [searchText]="vm.searchText"
                            (select)="handleSearchItemSelect($event)">
                        </rwidget-search-item>
                    </ng-container>
                </div>
            </div>

            <!--No Results-->
            <div
                class="m-4 text-center"
                *ngIf="
                    searchValue?.length > 0 &&
                    (!vm.results?.stopRoutes?.length || vm.results.stopRoutes.length === 0) &&
                    !vm.isLoading
                ">
                <div class="my-4 text-grey-dark dark:text-contrast-yellow">
                    <ion-icon class="text-4xl" [src]="(assetsPath$ | async) + '/img/no-search-results.svg'"> </ion-icon>
                </div>
                <p>{{ 'SEARCH_RESULTS_NOT_FOUND' | translate }}</p>
            </div>

            <ridango-ui-basic-loading-spinner *ngIf="vm.isLoading"></ridango-ui-basic-loading-spinner>
        </ng-container>
    </div>
</div>
